module.exports = __webpack_public_path__ + "static/media/the-green-milk-made-from-cells-twitter.872677f3.jpg";